import { render, staticRenderFns } from "./IconCompetencyGroup.vue?vue&type=template&id=95ab5430"
import script from "./IconCompetencyGroup.vue?vue&type=script&lang=js"
export * from "./IconCompetencyGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports